// src/lib/metaPixel.js
//
// Thin wrapper around the Meta Pixel's global fbq(), which is bootstrapped by the
// base code in public/index.html.
//
// Every call is guarded. fbq is absent whenever the loader was blocked -- ad
// blockers, browser tracking protection, corporate proxies, strict privacy modes
// -- which is a meaningful slice of real traffic. Analytics must never be able to
// break the page, so a missing fbq is a silent no-op rather than a TypeError
// escaping into a form's submit handler.

function fbqReady() {
  return typeof window !== "undefined" && typeof window.fbq === "function";
}

// Client-side route changes only. The base code already fires PageView for the
// document the browser actually loaded, so calling this on first paint would
// double-count every landing page.
export function trackPageView() {
  if (!fbqReady()) return;
  window.fbq("track", "PageView");
}

// Fire on a *successful* form submission -- never on click or on a failed POST,
// or the conversion counts drift away from the leads that actually reached the API.
//
// Deliberately takes no name, phone, pincode or company: those are the visitor's
// personal details and there is no reason to hand them to Meta. Pass only
// non-identifying context, e.g. which form variant was used.
export function trackLead(params) {
  if (!fbqReady()) return;
  window.fbq("track", "Lead", params);
}
